import ObjectEmployee from 'utils/objects/employee'
import _ from 'lodash'
import i18n from 'utils/i18n'
import React from 'react'
import DataItem from 'components/atoms/DataItem'
import { useIsInManagement } from 'utils/helper-linking'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import HelperDate, { dateFormat } from 'utils/helper-date'

export const ScannedInText = ( { item = {} } ) => {
	const isInManagement = useIsInManagement()
	
	// Only show this on web
	if( !isInManagement ) {
		return null;
	}
	
	const employee = ObjectEmployee.getLoggedIn();
	
	// Only show this for admins
	if( !ObjectEmployee.isAdmin( employee ) ) {
		return null;
	}
	
	let content = i18n.t('management:generic.scan.not_scanned_in');
	
	if( !_.isEmpty( item ) ) {
		content = i18n.t(`management:generic.scan.scanned_in_at.${item.scanned_in_through}`, {
			time: HelperDate.date( item.scanned_in_at ).format( dateFormat.SHORT_TIME )
		})
	}
	
	return (
		<DataItem
			icon={ <Icon icon={ IconSystemConstants.QRCODE } style={ [ DataItemStyles.headerIcon ] } /> }
			content={ content }>
			
			{ i18n.t('constants.scan_status') }
		</DataItem>
	)
}
